import {Translate} from '@mui/icons-material';
import {alpha, Button, Menu, MenuItem} from '@mui/material';
import {makeStyles} from '@mui/styles';
import React, {useState} from 'react';
import {getLanguage, getLanguages} from 'src/i18n';
import actions from 'src/modules/layout/layoutActions';
const useStyles = makeStyles((theme: any) => ({
  button: {
    color: theme.palette.getContrastText(theme.palette.primary.main),
  },
  text: {
    margin: theme.spacing(0, 0.5, 0, 1),
    display: 'none',
    color: theme.palette.getContrastText(theme.palette.primary.main),
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
}));

function I18nSelect(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  const doChangeLanguage = (language) => {
    actions.doChangeLanguage(language);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {/* oculto mientras no se implementen bien los otros idiomas */}
      <Button className={classes.button} onClick={handleClick}>
        <Translate
          sx={{
            color: alpha('#fff', 0.7),
          }}
        />
        <span className={classes.text}>{getLanguage().id.toUpperCase()}</span>
      </Button>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {getLanguages().map((language) => (
          <MenuItem key={language.id} onClick={(event) => doChangeLanguage(language.id)}>
            {language.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default I18nSelect;
